import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'loyal-react'
import MediaQuery from 'react-responsive'

const SubmitButton = ({ text, onClick, disabled, loading }) => (
  <div className='summary-order-submit row px-2 pt-2'>
    <div className='col-12 justify-content-center align-self-center'>
      <MediaQuery minDeviceWidth={769}>
        <Button
          className='btn-featured btn-icon'
          onClick={onClick}
          disabled={disabled}
          text={text}
          loading={loading}
        />
      </MediaQuery>
      <MediaQuery maxDeviceWidth={768}>
        <Button
          className='btn-featured'
          onClick={onClick}
          disabled={disabled}
          text={text}
          loading={loading}
        />
      </MediaQuery>
    </div>
  </div>
)

SubmitButton.propTypes = {
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func.isRequired
}

export default SubmitButton



// WEBPACK FOOTER //
// ./src/features/SummaryOrder/SubmitButton.js